import { naturalSort, reverseNaturalSort } from '@/helpers/util';

const formatter = 'multipleMetricsChart';

/**
 * Format the resultData and relevanceData into display data that can be passed into
 * <dp-chart>
 */
export default function formatMultipleMetricsChart(kpi, result) {
  const displayType = kpi.getDisplayType();
  let displayData = [];

  const isPercent = kpi.isPercent();
  // @TODO use multiple typeY once charts have multiple axes
  const { data, meta: { typeY0 } } = result;
  const metricFields = kpi.measurements.map((m) => m.label);

  const state = kpi.getState();
  const traceObjects = metricFields.reduce((acc, field) => {
    const dataObj = {
      key: field,
      type: kpi.getChartDisplayType(),
      values: [],
    };
    if (state[field] && state[field].visible === false) {
      dataObj.visible = false;
    }
    if (displayType === 'line') {
      const { displayOptions: { hideLineMarkers } } = kpi;
      dataObj.mode = hideLineMarkers ? 'lines' : 'lines+markers';
    }
    acc[field] = dataObj;
    return acc;
  }, {});

  data.forEach((dataPoint) => {
    Object.keys(traceObjects).forEach((traceName) => {
      const traceData = dataPoint[traceName];
      if (traceData) {
        traceObjects[traceName].values.push({
          x: dataPoint.x,
          y: typeY0 === 'percentage' ? traceData / 100 : traceData,
        });
      }
    });
  });

  displayData = Object.values(traceObjects);

  const sort = kpi.getSort();
  if (sort.order === 'desc') {
    displayData = reverseNaturalSort(displayData, 'key');
  } else {
    displayData = naturalSort(displayData, 'key');
  }
  return {
    displayType,
    displayData,
    isPercent,
    formatter,
  };
}
